/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "Loading"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var enGB = Object.assign(TranslationProviderComponent, {
  translations
});

export { enGB as e };
//# sourceMappingURL=en-GB-b46sjYFy.js.map
